import doctorViews from 'doctor/views';
import User from 'interfaces/User';
import sharedPaths from 'shared/routing/paths';
import isDoctor from 'shared/utils/isDoctor';
import sharedUserViews from 'shared/views';
import paths from './paths';

const accessGranted = (user: User): boolean => isDoctor(user);
const doctorAdminGranted = (doctor: User): boolean => isDoctor(doctor) && doctor.isAdmin;
const doctorAnalystGranted = (doctor: User): boolean => isDoctor(doctor) && doctor.isAnalyst;
const doctorCustomerCareGranted = (doctor: User): boolean =>
  isDoctor(doctor) && doctor.isCustomerCare;
const doctorNormalGranted = (doctor: User): boolean => isDoctor(doctor) && doctor.isNormal;

export const isGrantedToViewMetrics = (user: User): boolean =>
  doctorAdminGranted(user) || doctorAnalystGranted(user) || doctorNormalGranted(user);
export const isGrantedToViewPatients = accessGranted;
export const isGrantedToHandlePatients = (user: User): boolean =>
  doctorAdminGranted(user) || doctorNormalGranted(user) || doctorCustomerCareGranted(user);
export const isGrantedToViewTeam = (user: User): boolean =>
  doctorAdminGranted(user) || doctorAnalystGranted(user);
export const isGrantedToHandleTeam = (user: User): boolean => doctorAdminGranted(user);

export const USER_HOME = {
  isPrivate: true,
  accessGranted: accessGranted,
  component: doctorViews.UserHome,
  path: sharedPaths.USER_HOME,
  title: 'Inicio'
};

export const USER_PROFILE = {
  isPrivate: true,
  accessGranted: accessGranted,
  component: sharedUserViews.UserProfile,
  path: sharedPaths.USER_PROFILE,
  title: 'Tu perfil'
};

export const TEST_RESULT = {
  isPrivate: true,
  component: doctorViews.TestResult,
  path: paths.TEST_RESULT,
  accessGranted
};

export const NOTIFICATION_LIST = {
  isPrivate: true,
  component: sharedUserViews.NotificationList,
  path: sharedPaths.NOTIFICATION_LIST,
  title: 'Notificaciones',
  accessGranted
};

export const PATIENT_LIST = {
  isPrivate: true,
  component: doctorViews.PatientList,
  path: paths.PATIENT_LIST,
  title: 'Clientas/es',
  accessGranted: isGrantedToViewPatients
};

export const PATIENT_CREATE = {
  isPrivate: true,
  component: doctorViews.PatientCreate,
  path: paths.PATIENT_CREATE,
  title: 'Crear clienta/e',
  accessGranted
};

export const PATIENT_EDIT = {
  isPrivate: true,
  component: doctorViews.PatientEdit,
  path: paths.PATIENT_EDIT,
  accessGranted: isGrantedToHandlePatients
};

export const PATIENT_DETAIL = {
  isPrivate: true,
  component: doctorViews.PatientDetail,
  path: paths.PATIENT_DETAIL,
  accessGranted: isGrantedToViewPatients
};

export const PATIENT_RECOVER_PASSWORD = {
  isPrivate: true,
  component: doctorViews.PatientRecoverPassword,
  path: paths.PATIENT_RECOVER_PASSWORD,
  accessGranted: isGrantedToHandlePatients
};

export const PATIENT_DELETE = {
  isPrivate: true,
  component: doctorViews.PatientDelete,
  path: paths.PATIENT_DELETE,
  accessGranted: isGrantedToHandlePatients
};

export const COMPANY_DETAIL = {
  isPrivate: true,
  component: doctorViews.CompanyDetail,
  path: paths.COMPANY_DETAIL,
  title: 'Suscripción',
  accessGranted: doctorAdminGranted
};

export const COMPANY_EDIT = {
  isPrivate: true,
  component: doctorViews.CompanyEdit,
  path: paths.COMPANY_EDIT,
  title: 'Suscripción',
  accessGranted: doctorAdminGranted
};

export const COMPANY_METRICS = {
  isPrivate: true,
  component: doctorViews.CompanyMetrics,
  path: paths.COMPANY_METRICS,
  title: 'Métricas',
  accessGranted: isGrantedToViewMetrics
};

export const DOCTOR_LIST = {
  isPrivate: true,
  component: doctorViews.DoctorList,
  path: paths.DOCTOR_LIST,
  title: 'Equipo de BA',
  accessGranted: isGrantedToViewTeam
};

export const DOCTOR_EDIT = {
  isPrivate: true,
  component: doctorViews.DoctorEdit,
  path: paths.DOCTOR_EDIT,
  title: 'Editar equipo',
  accessGranted: isGrantedToHandleTeam
};

export const DOCTOR_CREATE = {
  isPrivate: true,
  component: doctorViews.DoctorCreate,
  path: paths.DOCTOR_CREATE,
  title: 'Crear miembro del equipo',
  accessGranted: isGrantedToHandleTeam
};

export const DOCTOR_DELETE = {
  isPrivate: true,
  component: doctorViews.DoctorDelete,
  path: paths.DOCTOR_DELETE,
  title: 'Eliminar miembro del equipo',
  accessGranted: isGrantedToHandleTeam
};

export const DOCTOR_RECOVER_PASSWORD = {
  isPrivate: true,
  component: doctorViews.DoctorRecoverPassword,
  path: paths.DOCTOR_RECOVER_PASSWORD,
  accessGranted: isGrantedToHandleTeam
};

export const LOGOUT = {
  isPrivate: true,
  accessGranted,
  component: sharedUserViews.Logout,
  path: sharedPaths.LOGOUT,
  title: null
};

export const CONTACT_FORM = {
  isPrivate: true,
  accessGranted,
  component: sharedUserViews.ContactForm,
  path: sharedPaths.CONTACT_FORM,
  title: 'Contacto'
};

export const INACTIVE_COMPANY = {
  isPrivate: true,
  accessGranted: doctorAdminGranted,
  component: doctorViews.InactiveCompany,
  path: paths.INACTIVE_COMPANY,
  title: null
};

const routes = [
  INACTIVE_COMPANY,
  CONTACT_FORM,
  LOGOUT,
  USER_HOME,
  USER_PROFILE,
  TEST_RESULT,
  PATIENT_CREATE,
  PATIENT_EDIT,
  PATIENT_DETAIL,
  PATIENT_DELETE,
  PATIENT_LIST,
  PATIENT_RECOVER_PASSWORD,
  NOTIFICATION_LIST,
  DOCTOR_CREATE,
  DOCTOR_LIST,
  DOCTOR_EDIT,
  DOCTOR_DELETE,
  DOCTOR_RECOVER_PASSWORD,
  COMPANY_EDIT,
  COMPANY_METRICS,
  COMPANY_DETAIL
];

export default routes;
